import React from 'react';

type IconProps = { className?: string };

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const SparklesIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2z" />
    <path d="M16 6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2z" />
    <path d="M9 18a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z" />
  </svg>
);

export const UsersIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
  </svg>
);

export const FlameIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z" />
  </svg>
);

export const TrendingUpIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M3 17l6 -6l4 4l8 -8" />
    <path d="M14 7l7 0l0 7" />
  </svg>
);

export const BanIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M5.7 5.7l12.6 12.6" />
  </svg>
);

export const CoinIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
    <path d="M12 7v-1" />
    <path d="M12 18v-1" />
  </svg>
);

export const SendIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M4.7 4.7l14.6 6.6a1 1 0 0 1 0 1.4l-14.6 6.6a0.55 0.55 0 0 1 -0.7 -0.7l2 -6.6l-2 -6.6a0.55 0.55 0 0 1 0.7 -0.7z" />
    <path d="M6 12h5" />
  </svg>
);

export const InfoIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01" />
    <path d="M11 12h1v4h1" />
  </svg>
);

export const MessageIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M8 9h8" />
    <path d="M8 13h4" />
    <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
  </svg>
);

export const ChevronLeftIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M15 6l-6 6l6 6" />
  </svg>
);

export const PencilIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4z" />
    <path d="M13.5 6.5l4 4" />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} {...svgProps}>
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </svg>
);
